import CertificadoClass from "src/app/model/api/certificados/certificadoClass";
import ApiService from "src/app/model/api/generic/apiService";

export default class CertificadosService extends ApiService {
 
    public async getCertificados(inspeccionId: number): Promise<CertificadoClass[]> {
        return await this.service.HttpGet('/api/certificados/getcertificados', {
            inspeccionId: inspeccionId
        })
    }
 
    public async generarCertificadoPrevisualizar(inspeccionId: number, certificadoId: number): Promise<boolean> {
        return await this.service.HttpGet('/api/certificados/generarCertificadoPrevisualizar', {
            inspeccionId: inspeccionId,
            certificadoId: certificadoId
        })
    }
        
    public async generarCertificado(inspeccionId: number, certificadoId: number): Promise<boolean> {
        return await this.service.HttpGet('/api/certificados/generarCertificado', {
            inspeccionId: inspeccionId,
            certificadoId: certificadoId
        })
    }

    public async obtenerCertificado(inspeccionId: number, certificadoId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/certificados/obtenerCertificado', {
            inspeccionId: inspeccionId,
            certificadoId: certificadoId
        })
    }

    public async getFicheroFirmaCualificada(inspeccionId: number, certificadoId: number): Promise<string> {
        return await this.service.HttpGetDownloadBase64('/api/certificados/getFicheroFirmaCualificada', {
            inspeccionId: inspeccionId,
            certificadoId: certificadoId
        })
    }

    public async obtenerLinkParaFirmar(inspeccionId: number, listaCertificadosIds: number[]): Promise<string> {
        return await this.service.HttpPost('/api/certificados/obtenerLinkParaFirmar', {
            inspeccionId: inspeccionId,
            listaCertificadosIds: listaCertificadosIds  
        })
    }

    public async SubirFicheroFirmaCualificada(inspeccionId: number, certificadoId: number, file: File) {
        let formData = new FormData()
        formData.append('Data', JSON.stringify({
            InspeccionId: inspeccionId,
            CertificadoId: certificadoId,
            FileName: file.name,
        }))
        formData.append('Fichero', file)
        await this.service.HttpPostFormData('/api/certificados/subirFicheroFirmaCualificada', formData)
    }

    public async deleteCertificados(inspeccionId: number): Promise<void> {
        return await this.service.HttpDelete('/api/certificados/deleteCertificados', {
            inspeccionId: inspeccionId
        })
    }

    public async subirFicheroFirmaInspector(certificadoId: number): Promise<void> {
        return await this.service.HttpGet('/api/certificados/subirFicheroFirmaInspector', {
            certificadoId: certificadoId
        })
    }

}